import { UserIconMenu } from '@framework/ui/elements/TopNavigation';
import type { GroupEntity } from '@group/domain';
import { SidebarOpenButton, useSidebarContext } from '@user/Sidebar';
import { Link } from 'react-router';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { useSnapshot } from '@framework/hooks/useSnapshot';
import { RTDBPath } from 'balus-common';
import type { GroupMemberRoleJSON } from 'balus-common';
import { NotificationIcon } from '../ViewModelPage/FloatingUIContainer/HeaderMenuFirst/HeaderMenuRight/NotificationIcon';
import { useCallback, useState } from 'react';
import { NotificationList } from '@user/notification';
import { BannerAnnouncement } from '@user/notification/BannerAnnouncement';
import { useTranslation } from 'react-i18next';

type Props = {
  currentGroup: GroupEntity;
  currentUserId: string;
};

export const HEADER_HEIGHT = 64;

export const Header: React.FC<Props> = ({ currentGroup, currentUserId }: Props) => {
  const { t } = useTranslation();
  const [role] = useSnapshot<GroupMemberRoleJSON>({
    path: RTDBPath.Group.memberRolePath(currentGroup.id, currentUserId),
    load: ({ snapshot }) => snapshot.val(),
  });

  const { isSidebarOpenButtonVisible, toggleSidebar } = useSidebarContext();

  const [showNotifications, setShowNotifications] = useState(false);
  const onToggleNotifications = useCallback(() => {
    setShowNotifications(!showNotifications);
  }, [showNotifications]);
  const onNotificationListClose = useCallback(() => setShowNotifications(false), []);

  return (
    <div className="border-b-2">
      <div className="flex items-center" style={{ height: HEADER_HEIGHT - 2 }}>
        {isSidebarOpenButtonVisible && (
          <div className="size-12">
            <SidebarOpenButton onClick={toggleSidebar} />
          </div>
        )}
        <div className="ml-auto flex items-center justify-items-stretch gap-x-4 p-2">
          {role === 'admin' && (
            <>
              <Link to={UserPagePathBuilder.groupConsolePage(currentGroup.id)} className="text-brand">
                {t('group.header.consoleLink')}
              </Link>
            </>
          )}
          <div className="relative">
            <NotificationIcon
              className="pointer-events-auto"
              showNotifications={showNotifications}
              onToggle={onToggleNotifications}
              showButtonShadow={false}
            />
            {showNotifications && (
              <div className="absolute right-0 top-[80px] z-10">
                <NotificationList onClose={onNotificationListClose} />
              </div>
            )}
          </div>
          <UserIconMenu userId={currentUserId} />
        </div>
      </div>
      {!showNotifications && (
        <div className="pointer-events-none absolute left-0 top-0 flex size-full px-10 py-16">
          <BannerAnnouncement />
        </div>
      )}
    </div>
  );
};
